// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3J5G0","menu_button":"style_menu_button__HvXcp"};